export const toStoresOptions = stores =>
  stores.map(store => ({
    value: store.shopCode,
    label: store.shopName,
    idReturo: store.idReturo
  }))
